module.exports = __webpack_public_path__ + "assets/img/kv-f95d9414.png";